import React from "react"
import { Route, Redirect, withRouter } from "react-router-dom"
import { useSelector } from "react-redux"

import {
  GUEST,
  COMPANY_PROVIDER,
  COMPANY_SEEKER,
  INDIVIDUAL,
  ADMIN,
  COMPANY_ADMIN,
  ASSOCIATE_COMPANY_ADMIN,
  COMPANY_EMPLOYEE,
} from "./userRoles"
import { paths } from "../routes/paths"
import Loading from "../components/Loading/Loading"

// Routes that should be blocked in production environment
const productionBlockedRoutes = ["/institute-search", "/inspiration-search"]

const RouteWithSubRoutes = ({ allowed, exact, path, routes, Component }) => {
  const userInfo = useSelector((state) => state.user)
  const env = process.env.REACT_APP_ENV

  // Block access to certain routes in production environment
  if (env === "production") {
    const isBlockedRoute = productionBlockedRoutes.some(
      (blockedPath) => path === blockedPath || path.startsWith(blockedPath)
    )
    if (isBlockedRoute) {
      return <Redirect to={paths.home} />
    }
  }

  if (
    !allowed.includes(userInfo.role) &&
    !allowed.includes(userInfo.company?.type)
  ) {
    switch (userInfo.role) {
      case GUEST:
        return <Redirect to={paths.login} />
      case COMPANY_ADMIN:
      case ASSOCIATE_COMPANY_ADMIN:
      case COMPANY_EMPLOYEE:
        return <Redirect to={paths.companyProfile} />
      case INDIVIDUAL:
        return <Redirect to={paths.individualProfile} />
      case ADMIN:
        return <Redirect to={paths.adminDashboard} />
      default:
        return <Redirect to={paths.login} />
    }
  }

  return (
    <React.Suspense fallback={<Loading />}>
      <Route
        exact={exact}
        path={path}
        render={(props) => <Component {...props} routes={routes} />}
      />
    </React.Suspense>
  )
}

export default withRouter(RouteWithSubRoutes)
